import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-user-profile",
    templateUrl: "./user-profile.component.html",
    standalone: false
})
export class UserProfileComponent implements OnInit {
  
  constructor( ) { }

  ngOnInit() { }
}
